module.exports = __webpack_public_path__ + "img/pic_6.5d9c499f.jpg";